import * as monsterData from './tables/monster.data.cs.json';
import { IReferenceTable } from "./interfaces/ITable";
import { MonsterDataType } from "./models/MonsterData";

const CursedScrollMonsterReferenceTable: IReferenceTable<MonsterDataType> = monsterData as IReferenceTable<MonsterDataType>;

export default CursedScrollMonsterReferenceTable;
